<mat-drawer-container class="example-container">
  <mat-drawer
    #drawer
    class="modal-drawer"
    mode="over"
    position="end"
    (click)="onBackgroundClick($event)"
  >
    <ng-container #dynamicContainer></ng-container>
  </mat-drawer>
</mat-drawer-container>
